import { useTranslate } from '@refinedev/core';
import type { CrudFilter } from '@refinedev/core';
import type { SetFilters } from '@/utils/filters';
import { SelectFilter } from './SelectFilter';

type BooleanFilterProps = {
  field: string;
  filters: CrudFilter[];
  confirm: () => void;
  clearFilters?: () => void;
  setFilters: SetFilters;
  placeholder?: string;
};

/** Yes/no column filter, applied as `field[eq]`. */
export const BooleanFilter = ({
  field,
  filters,
  confirm,
  clearFilters,
  setFilters,
  placeholder,
}: BooleanFilterProps) => {
  const t = useTranslate();

  return (
    <SelectFilter<boolean>
      field={field}
      options={[
        { label: t('common.yes'), value: true },
        { label: t('common.no'), value: false },
      ]}
      filters={filters}
      confirm={confirm}
      clearFilters={clearFilters}
      setFilters={setFilters}
      placeholder={placeholder}
    />
  );
};
